module.exports = __webpack_public_path__ + "static/media/image-5.7204443e.avif";